import { useTranslation } from 'react-i18next';

const products = [
  {
    name: 'Nike Air Max 97 Silver Bullet',
    price: '549 zł',
    category: 'Buty',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20Nike%20Air%20Max%2097%20silver%20bullet%20sneaker%20photographed%20from%20side%20angle%20on%20a%20warm%20cream%20paper%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20diffused%20studio%20lighting%20from%20above%2C%20metallic%20silver%20texture%20visible%2C%20isolated%20on%20light%20neutral%20surface%2C%20professional%20ecommerce%20catalog%20style%2C%20high%20detail%20fabric%20texture&width=560&height=560&seq=prod-sneaker-v3a&orientation=squarish',
  },
  {
    name: 'Essentials Knit Sweater Oatmeal',
    price: '329 zł',
    category: 'Bluzy / Swetry',
    image: 'https://readdy.ai/api/search-image?query=A%20chunky%20knit%20oatmeal%20colored%20sweater%20neatly%20folded%20on%20a%20light%20beige%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20fashion%20flat%20lay%20photography%2C%20visible%20knit%20texture%20and%20ribbing%20details%2C%20clean%20warm%20aesthetic%2C%20high%20end%20catalog%20style%2C%20neutral%20tones&width=560&height=560&seq=prod-hoodie-v3b&orientation=squarish',
  },
  {
    name: 'Arcteryx Beta LT Jacket Graphite',
    price: '1350 zł',
    category: 'Kurtki',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20graphite%20grey%20technical%20shell%20jacket%20laid%20flat%20on%20a%20light%20warm%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20studio%20lighting%2C%20technical%20fabric%20texture%20visible%2C%20minimalist%20outdoor%20gear%20aesthetic%2C%20professional%20ecommerce%20style&width=560&height=560&seq=prod-jacket-v3c&orientation=squarish',
  },
  {
    name: 'Acne Studios Denim Straight Fit',
    price: '420 zł',
    category: 'Spodnie / Szorty',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20light%20wash%20blue%20denim%20jeans%20folded%20neatly%20on%20a%20warm%20beige%20linen%20surface%2C%20clean%20minimal%20product%20photography%2C%20soft%20natural%20lighting%20from%20window%2C%20denim%20texture%20visible%2C%20contemporary%20fashion%20ecommerce%20style%2C%20neutral%20tones&width=560&height=560&seq=prod-pants-v3d&orientation=squarish',
  },
  {
    name: 'Ralph Lauren Cable Knit Beanie',
    price: '89 zł',
    category: 'Nakrycia głowy',
    image: 'https://readdy.ai/api/search-image?query=A%20camel%20colored%20cable%20knit%20wool%20beanie%20hat%20on%20a%20warm%20cream%20surface%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20visible%20knit%20pattern%20texture%2C%20front%20view%2C%20modern%20ecommerce%20style%2C%20cozy%20autumn%20winter%20aesthetic&width=560&height=560&seq=prod-cap-v3e&orientation=squarish',
  },
  {
    name: 'Porter-Yoshida Tanker Shoulder Bag',
    price: '680 zł',
    category: 'Torby',
    image: 'https://readdy.ai/api/search-image?query=A%20sage%20green%20Porter-Yoshida%20Tanker%20nylon%20shoulder%20bag%20on%20a%20clean%20light%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20front%20view%20showing%20iconic%20label%2C%20Japanese%20craftsmanship%20aesthetic%2C%20premium%20ecommerce%20style&width=560&height=560&seq=prod-bag-v3f&orientation=squarish',
  },
  {
    name: 'Le Labo Santal 33 Perfume',
    price: '950 zł',
    category: 'Perfumy',
    image: 'https://readdy.ai/api/search-image?query=A%20Le%20Labo%20Santal%2033%20glass%20perfume%20bottle%20with%20apothecary%20label%20on%20a%20warm%20cream%20marble%20surface%2C%20clean%20luxury%20product%20photography%2C%20soft%20natural%20light%2C%20minimalist%20composition%2C%20amber%20liquid%20visible%20through%20glass%2C%20sophisticated%20niche%20fragrance%20aesthetic&width=560&height=560&seq=prod-perfume-v3g&orientation=squarish',
  },
  {
    name: 'Vintage Adidas Originals Jersey',
    price: '159 zł',
    category: 'Koszulki sportowe',
    image: 'https://readdy.ai/api/search-image?query=A%20vintage%20style%20Adidas%20Originals%20trefoil%20football%20jersey%20in%20navy%20blue%20with%20white%20stripes%2C%20laid%20flat%20on%20a%20warm%20light%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20studio%20lighting%2C%20retro%20sport%20aesthetic%2C%20visible%20fabric%20texture%2C%20nostalgic%2090s%20style&width=560&height=560&seq=prod-jersey-v3h&orientation=squarish',
  },
];

export default function ProductScroll() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            {t('products.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            {t('products.subtitle')}
          </p>
        </div>

        {/* Horizontal Scroll */}
        <div className="flex gap-4 overflow-x-auto pb-4 -mx-6 px-6 md:-mx-10 md:px-10 snap-x snap-mandatory">
          {products.map((product) => (
            <a
              key={product.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[240px] md:w-[280px] snap-start group cursor-pointer"
            >
              <div className="rounded-xl overflow-hidden bg-background-50 border border-background-200/60 group-hover:border-accent-300 transition-all">
                <div className="aspect-square overflow-hidden bg-background-100/50">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <p className="text-xs text-foreground-400 mb-1">{product.category}</p>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {product.name}
                  </h3>
                  <p className="mt-2 text-sm font-bold text-foreground-900">
                    {product.price}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('categories.view_all')}
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}